// Header component - Latest update: 2026-01-08
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled(Link)`
  font-weight: bold;
  font-size: 24px;
  color: ${props => props.theme.colors.text};
  text-decoration: none;
  font-family: 'Carter One', cursive;
`;

const Nav = styled.nav`
  display: flex;
  gap: 20px;
  align-items: center;
`;

const NavLink = styled(Link)`
  color: ${props => props.theme.colors.secondary};
  text-decoration: none;
  font-size: 14px;
  
  &:hover {
    color: ${props => props.theme.colors.primary};
  }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const UserName = styled.span`
  font-size: 14px;
`;

const LogoutButton = styled.button`
  background-color: transparent;
  color: ${props => props.theme.colors.secondary};
  padding: 5px 10px;
  
  &:hover {
    background-color: ${props => props.theme.colors.highlight};
    color: ${props => props.theme.colors.text};
  }
`;

function Header({ user, onLogout }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <HeaderContainer>
      <Logo to="/">Kritics</Logo>
      <Nav>
        {user ? (
          <>
            <NavLink to="/wanna-watch">Wanna Watch</NavLink>
            <NavLink to="/my-movies">My Movies</NavLink>
            <NavLink to="/kritics">Kritics</NavLink>
            <NavLink to="/about">About</NavLink>
            <UserInfo>
              {user.isAdmin && (
                <NavLink to="/admin" style={{ color: 'red', marginRight: '10px' }}>
                  Admin
                </NavLink>
              )}
              <NavLink to="/profile">
                <UserName>{user.username}</UserName>
              </NavLink>
              <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
            </UserInfo>
          </>
        ) : (
          <>
            <NavLink to="/about">About</NavLink>
            <NavLink to="/login">Login</NavLink>
            <NavLink to="/register">Register</NavLink>
          </>
        )}
      </Nav>
    </HeaderContainer>
  );
}

export default Header;